interface BarcodeListProps {
  barcodes: string[];
  label: string;
  formatNumber: (value: number) => string;
}

const SCROLL_THRESHOLD = 8;

export function BarcodeList({ barcodes, label, formatNumber }: BarcodeListProps) {
  if (barcodes.length === 0) return null;

  return (
    <div className="overflow-hidden rounded-lg border border-border/70 bg-secondary/10">
      <div className="flex items-center justify-between gap-3 border-b border-border/60 px-3 py-2.5">
        <p className="text-xs text-muted-foreground font-medium uppercase tracking-wider">
          {label}
        </p>
        {barcodes.length > 1 && (
          <span className="rounded bg-secondary px-1.5 py-0.5 text-[11px] font-bold tabular-nums text-muted-foreground">
            {formatNumber(barcodes.length)}
          </span>
        )}
      </div>
      <div className={barcodes.length > SCROLL_THRESHOLD ? "max-h-40 overflow-y-auto" : ""}>
        <div className="grid grid-cols-1 gap-1.5 p-3 sm:grid-cols-2">
          {barcodes.map((barcode) => (
            <span
              key={barcode}
              className="rounded-md border border-border/60 bg-background/55 px-2 py-1.5 font-mono text-xs font-semibold tabular-nums text-foreground"
              title={barcode}
            >
              {formatBarcodeForDisplay(barcode)}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export function formatBarcodeForDisplay(barcode: string): string {
  const trimmed = barcode.trim();
  const digits = trimmed.replace(/\D/g, "");

  if (digits.length === trimmed.length) {
    if (digits.length === 8) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
    if (digits.length === 12) {
      return `${digits.slice(0, 1)} ${digits.slice(1, 6)} ${digits.slice(6, 11)} ${digits.slice(11)}`;
    }
    if (digits.length === 13)
      return `${digits.slice(0, 1)} ${digits.slice(1, 7)} ${digits.slice(7)}`;
  }

  return trimmed.replace(/(.{4})(?=.)/g, "$1 ");
}
